import { PageLayout } from '@retail/components';
import { Paper } from '@shared/components';
import { MemberConfigContainer } from '@retail/member-config/containers';

export function MemberConfigPage() {
  return (
    <PageLayout maxWidth="full" spacing={2} fixedHeight>
      <Paper
        sx={{
          display: 'flex',
          flexDirection: 'column',
          height: '100%',
          py: 2.5,
          px: 0,
          overflow: 'hidden',
        }}
      >
        <MemberConfigContainer />
      </Paper>
    </PageLayout>
  );
}
